module.exports = new __parcel__URL__("icons.7ee4a911.svg").toString();